import React, { useState, useEffect } from "react";
import styles from "../../../style/Pages/PopUp/InvitePopUp.module.css";
import { TfiClose } from "react-icons/tfi";
// import { getSelectedCompany } from "../../../utils/auth";
import { useFetchSelectedUser } from "../../../hooks/useCommonHooks";
import { useEditChannelAction } from "../../../hooks/useChannel";
import { useGroupEditAction } from "../../../hooks/useGroup";
import FallbackAvatar from "../../../components/ui/FallbackAvatar/FallbackAvatar";

const InvitePopup = ({ onClose, Id, company, Updated, OpenFrom, PeopleId }) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const excludedUserIds = new Set(PeopleId?.map((people) => String(people.id)));

  const apiUrl = process.env.REACT_APP_API_URL;
  // const CompanyId = getSelectedCompany();
  const [searchTerm, setSearchTerm] = useState("");

  const [debouncedSearch, setDebouncedSearch] = useState("");
  const users = useFetchSelectedUser(company, debouncedSearch);
  const filteredUsers = users.filter(
    (user) => !excludedUserIds.has(String(user.id))
  );
  const handleClose = () => {
    setSelectedEmployees([]); // Clear selections
    setSearchTerm(""); // Reset search
    onClose(); // Close popup
  };

  const channelHook = useEditChannelAction(Id);
  const groupHook = useGroupEditAction(Id);
  const isGroup = OpenFrom === "group";
  // const isLoading = isGroup ? groupHook.isLoading : channelHook.isLoading;

  const handleAsMember = async () => {
    try {
      if (isGroup) {
        await groupHook.editGroupAction({ add_group_user: selectedEmployees });
      } else {
        await channelHook.editActionChannel({
          channel_people: selectedEmployees,
        });
      }
      Updated(); // Notify parent of successful update
      handleClose(); // Clear state and close
    } catch (error) {}
    // setActiveDropdown(null);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
    }, 500); // 500ms delay
    return () => clearTimeout(handler);
  }, [searchTerm]);
  return (
    <div className={styles.invitePopupOverlay}>
      <div className={styles.invitePopup} onClick={(e) => e.stopPropagation()}>
        <div className={styles.inviteHeader}>
          <h3>Invite</h3>
          <div className={styles.closeButton} onClick={onClose}>
            <TfiClose size={18} />
          </div>
        </div>

        <div className={styles.searchContainer}>
          <input
            type="text"
            placeholder="Search employees..."
            className={styles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className={styles.employeeList}>
          {filteredUsers.map((employee) => (
            <div
              key={employee.id}
              className={`${styles.employeeItem} ${
                selectedEmployees.includes(employee.id) ? styles.selected : ""
              }`}
              onClick={() =>
                setSelectedEmployees((prev) =>
                  prev.includes(employee.id)
                    ? prev.filter((id) => id !== employee.id)
                    : [...prev, employee.id]
                )
              }
            >
              <div className={styles.employeeInfo}>
                {employee.emp_pic ? (
                  <img
                    src={`${apiUrl}${employee.emp_pic}` || ""}
                    alt={`${employee.name}`}
                    className={styles.avatar}
                    // onError={(e) => {
                    //   e.target.src = "/default-avatar.png";
                    // }}
                  />
                ) : (
                  <FallbackAvatar name={employee.name} size={36} />
                )}

                <div>
                  <h5>{employee.name}</h5>
                  <p className={styles.jobTitle}>{employee.designation}</p>
                </div>
              </div>
              <input
                type="checkbox"
                checked={selectedEmployees.includes(employee.id)}
                onChange={() => {}}
                className={styles.checkbox}
              />
            </div>
          ))}
        </div>

        <div className={styles.inviteActions}>
          {/* <button className={styles.cancelButton}>Cancel</button> */}
          <button
            className={styles.inviteButton}
            disabled={selectedEmployees.length === 0}
            onClick={handleAsMember}
          >
            Add Selected ({selectedEmployees.length})
          </button>
        </div>
      </div>
    </div>
  );
};
export default InvitePopup;
